import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-26a5973c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container wow animate__animated animate__fadeInUp",
  "data-wow-duration": "2s",
  "data-wow-delay": "0.2s"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", {
    class: "title"
  }, "应用中心", -1);
});

var _hoisted_3 = {
  class: "row"
};
var _hoisted_4 = {
  class: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
};
var _hoisted_5 = ["src", "alt"];

var _hoisted_6 = /*#__PURE__*/_createTextVNode("了解更多");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productShow, function (p) {
    return _openBlock(), _createElementBlock("li", {
      key: p.id
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: "thumbnail long-thumbnail",
      onClick: _cache[0] || (_cache[0] = function () {
        return $setup.goProduct && $setup.goProduct.apply($setup, arguments);
      })
    }, [_createElementVNode("img", {
      src: p.imgUrl,
      alt: p.name
    }, null, 8, _hoisted_5), _createElementVNode("h3", null, _toDisplayString(p.name), 1)])])]);
  }), 128))])]), _createVNode(_component_router_link, {
    class: "more",
    to: "/product"
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  })]);
}